import { Component, Prop, Vue } from "vue-property-decorator";

// Helpers
import {
  orderStatusToSpanish,
  subscriptionStatusToSpanish,
  isOrderInTerminalStatus,
  subscriptionDetailsStatusToSpanish,
} from "@/plugins/subscriptions_helper";

@Component({})
export default class SubscriptionStatusBadge extends Vue {
  @Prop({ default: "next-order" }) orderType;
  @Prop({ default: null }) order;

  get getBadgeStatus() {
    switch (this.orderType) {
      case "last-order":
        return orderStatusToSpanish(this.order.status);
      case "subscription-details":
        return subscriptionDetailsStatusToSpanish(this.order);
      default:
        return subscriptionStatusToSpanish(this.order);
    }
  }

  get isLastOrderInTerminalStatus() {
    return isOrderInTerminalStatus(this.order);
  }

  get isLastOrder() {
    return this.orderType === "last-order";
  }
}
